import axios, { AxiosError } from "axios";
import { AuthTokenError } from "../../errors/authTokenError";

/**
 * Configuração para as APIs do RC
 * @param authContext - Contexto de autenticação
 * @param Authorization - Token de autorização
 * @returns Instância da API configurada
 */

export function SetupRC(Authorization: string = "") {
  const baseURL =
    import.meta.env.MODE === "production"
      ? import.meta.env.VITE_BASE_URL_PROD
      : import.meta.env.VITE_BASE_URL_DEV;

  const api = axios.create({
    baseURL,
    headers: {
      Authorization: Authorization,
      // 'ngrok-skip-browser-warning': '69420',
    },
  });

  api.interceptors.response.use(
    (response) => response,
    (error: AxiosError) => {
      if (error.response?.status === 401) {
        // signOut?.();
        return typeof window === "undefined"
          ? Promise.reject(new AuthTokenError())
          : Promise.reject(error);
      }
      return Promise.reject(error);
    }
  );

  return api;
}
